import React from 'react'

const Info = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="31" height="28" viewBox="0 0 31 28" fill="none">
      <path d="M14.1036 0.893125L18.9808 20.1629L26.8986 22.7279C27.1392 22.8059 27.2703 23.0619 27.1914 23.2995C27.1124 23.5371 26.8535 23.6665 26.6129 23.5885L18.5243 20.9682H8.58442L1.17526 23.5848C0.936876 23.6689 0.674642 23.5462 0.589376 23.3108C0.504126 23.0753 0.628318 22.8161 0.866757 22.7319L8.12279 20.1693L13.2151 0.888703L14.1036 0.893125ZM9.09866 20.0625H18.0103L13.6492 2.83306L9.09866 20.0625Z" fill="#494949"/>
      <path d="M27.7608 23.629L13.5897 28L0 23.6261L13.5843 0L27.7608 23.629ZM14.0513 26.9087L26.381 23.1056L14.0513 2.55488V26.9087ZM1.35198 23.1087L13.1343 26.9008V2.61636L1.35198 23.1087Z" fill="#494949"/>
      <path d="M30.4298 25.0054L29.3296 26.4549L2.32312 5.53528L3.42324 4.08558L30.4298 25.0054Z" fill="#494949"/>
    </svg>
  )
}

export default Info
